export default {
  trust_subtitle: 'Private Ausflüge in Ägypten mit persönlichem Service und deutschsprachiger Betreuung.',
contact_cta: 'Jetzt unverbindlich anfragen',
  // === Top Header ===
  top_whatsapp: 'WhatsApp',
  top_phone: 'Telefon',
  top_quick_booking: 'Jetzt anfragen',
  top_currency_eur: 'EUR',
  top_currency_usd: 'USD',
  top_currency_gbp: 'GBP',

  // === Main Navigation ===
  nav_home: 'Startseite',
  nav_hurghada: 'Hurghada Ausflüge',
  nav_marsa_alam: 'Marsa Alam Ausflüge',
  nav_transfers: 'Transfers',
  nav_about: 'Über uns',
  nav_contact: 'Kontakt',

  // === Hero ===
  hero_headline: 'Ägypten exklusiv erleben',
  hero_subheadline: 'Private Ausflüge, Transfers und deutschsprachige Reiseleitung in Hurghada, Marsa Alam, Luxor und Kairo. Keine Anzahlung erforderlich – Bezahlung vor Ort.',
  hero_cta_primary: 'Ausflüge entdecken',
  hero_cta_secondary: 'Per WhatsApp anfragen',

  // === Trust Badges ===
  trust_title: 'Warum Yallabina Tours?',
  trust_experience: 'Über 10 Jahre Erfahrung',
  trust_no_deposit: 'Keine Anzahlung nötig',
  trust_pay_on_site: 'Bezahlung vor Ort',
  trust_licensed: 'Lizenzierte Ägyptologen',
  trust_german_guides: 'Deutschsprachige Guides',
  trust_private_cars: 'Private Fahrzeuge',
  trust_transparent: 'Transparente Preise',
  trust_individual: 'Individuelle Betreuung',
  trust_support: '24/7 WhatsApp Support',
  hurghada_tours_title: 'Ausflüge ab Hurghada',
hurghada_tours_subtitle: 'Unsere beliebtesten privaten Ausflüge mit deutschsprachiger Reiseleitung.',
marsa_alam_tours_title: 'Ausflüge ab Marsa Alam',
marsa_alam_tours_subtitle: 'Private Touren und Erlebnisse ab Marsa Alam mit deutschsprachiger Reiseleitung.',

  // === Tours from Hurghada ===
  hurghada_title: 'Ausflüge ab Hurghada',
  hurghada_subtitle: 'Exklusive Privatausflüge mit deutschsprachigen Ägyptologen von Hurghada aus',
  hurghada_badge: 'Hurghada',

  // === Tours from Marsa Alam ===
  marsa_alam_title: 'Ausflüge ab Marsa Alam',
  marsa_alam_subtitle: 'Entdecken Sie die schönsten Ausflüge ab Marsa Alam mit deutschsprachiger Reiseleitung, privaten Transfers und persönlichem Service.',
  marsa_alam_badge: 'Marsa Alam',

  // === Tour Card ===
  tour_from: 'Ab',
  tour_per_person: 'pro Person',
  tour_book_now: 'Jetzt anfragen',
  tour_details: 'Details',
  tour_half_day: 'Halbtagestour',
  tour_full_day: 'Tagesausflug',
  tour_multi_day: 'Mehrtägig',

  // === Tour Detail ===
  tour_overview: 'Überblick',
  tour_highlights: 'Highlights',
  tour_itinerary: 'Reiseverlauf',
  tour_included: 'Im Preis enthalten',
  tour_excluded: 'Nicht enthalten',
  tour_tips: 'Reisetipps',
  tour_duration: 'Dauer',
  tour_meeting_point: 'Hotelabholung inklusive',
  tour_languages: 'Deutschsprachiger Guide',
  tour_faq: 'Häufige Fragen',
  tour_reviews: 'Kundenbewertungen',
  tour_gallery: 'Galerie',
  tour_price_table: 'Preistabelle',
  tour_price_from: 'Preis ab',
  tour_pickup_included: 'Hotelabholung inklusive',
  tour_english_guide: 'Deutschsprachiger Guide',
  tour_booking_form: 'Buchungsanfrage',
  tour_select_date: 'Reisedatum',
  tour_adults: 'Erwachsene',
  tour_children: 'Kinder',
  tour_hotel: 'Hotelname',
  tour_whatsapp: 'WhatsApp-Nummer',
  tour_special_requests: 'Besondere Wünsche',
  tour_submit_request: 'Jetzt unverbindlich anfragen',
  tour_request_sent: 'Anfrage gesendet!',
  tour_request_message: 'Wir werden uns innerhalb von 24 Stunden bei Ihnen melden.',
  tour_no_online_payment: 'Keine Online-Zahlung erforderlich. Sie bezahlen direkt vor Ort.',
  tour_full_name: 'Vollständiger Name',
  tour_email_address: 'E-Mail-Adresse',
  tour_phone_number: 'Telefonnummer',

  // === Trust Section ===
  trust_section_title: 'Warum mit Yallabina Tours buchen?',
  trust_no_deposit_detail: 'Keine Anzahlung',
  trust_pay_onsite_detail: 'Zahlung vor Ort',
  trust_licensed_detail: 'Lizenzierter Guide',
  trust_german_detail: 'Deutschsprachiger Service',
  trust_private_detail: 'Private Transfers',
  trust_transparent_detail: 'Transparente Preise',
  trust_individual_detail: 'Individuelle Touren',
  trust_support_detail: '24/7 WhatsApp Support',

  // === Reservation Cart ===
  cart_title: 'Ihre Buchungsanfragen',
  cart_empty: 'Keine Ausflüge ausgewählt',
  cart_empty_desc: 'Fügen Sie Ausflüge hinzu, um eine Buchungsanfrage zu senden.',
  cart_tour: 'Ausflug',
  cart_date: 'Datum',
  cart_guests: 'Gäste',
  cart_hotel: 'Hotel',
  cart_total: 'Gesamtpreis',
  cart_customer_info: 'Kundendaten',
  cart_name: 'Vollständiger Name',
  cart_email: 'E-Mail-Adresse',
  cart_phone: 'Telefonnummer',
  cart_notes: 'Besondere Wünsche',
  cart_send_request: 'Buchungsanfrage senden',
  cart_remove: 'Entfernen',
  cart_add_more: 'Weitere Ausflüge',
  cart_success_title: 'Vielen Dank!',
  cart_success_message: 'Ihre Buchungsanfrage wurde erfolgreich übermittelt. Wir melden uns innerhalb von 24 Stunden.',

  // === Transfers ===
  transfers_title: 'Transfers',
  transfers_subtitle: 'Private Flughafentransfers und Limousinenservice in der gesamten Region',
  transfers_airport_hurghada: 'Flughafen Hurghada',
  transfers_airport_marsa_alam: 'Flughafen Marsa Alam',
  transfers_hotel: 'Hoteltransfer',
  transfers_limousine: 'Privat Limousine',
  transfers_minibus: 'Privat Minibus',
  transfers_from: 'Von',
  transfers_to: 'Nach',
  transfers_duration: 'Fahrzeit',
  transfers_price: 'Preis',
  transfers_vehicle: 'Fahrzeug',
  transfers_book: 'Transfer buchen',
  transfers_destinations: 'Transfer Ziele',
  transfers_route_info: 'Streckeninformation',
  transfers_vehicle_types: 'Fahrzeugtypen',

  // === About Us ===
  about_title: 'Über Yallabina Tours',
  about_subtitle: 'Ihr vertrauenswürdiger Partner für exklusive Ägypten-Erlebnisse',
  about_story: 'Unsere Geschichte',

about_story_text: 'Yallabina Tours begleitet seit über 15 Jahren deutschsprachige Reisende durch Ägypten. Mit Leidenschaft, Erfahrung und persönlicher Betreuung zeigen wir Ihnen nicht nur Sehenswürdigkeiten – sondern das echte Ägypten.',

about_mission: 'Unsere Mission',

about_mission_text: 'Jede Reise wird individuell geplant. Keine Massenabfertigung, keine versteckten Kosten und keine Shoppingstopps. Stattdessen erleben Sie Ägypten entspannt mit deutschsprachigen Guides und persönlichem Service – vom ersten Kontakt bis zur Rückkehr ins Hotel.Ob Luxor, Kairo, Hurghada oder Marsa Alam – wir gestalten jede Tour so, als würden wir Freunde durch unser eigenes Land begleiten.',

about_expertise: 'Lokale Expertise',
about_expertise_text: 'Unsere ortskundigen Reiseleiter kennen Ägypten bis ins Detail und zeigen Ihnen Orte, Geschichten und Erlebnisse, die vielen Besuchern verborgen bleiben.',

about_safety: 'Sicherheit & Vertrauen',
about_safety_text: 'Moderne Fahrzeuge, lizenzierte Guides und transparente Preise sorgen dafür, dass Sie Ihre Reise entspannt und sicher genießen können.',

about_flexibility: 'Flexibilität',
about_flexibility_text: 'Jede Tour wird individuell an Ihre Wünsche angepasst – ohne Zeitdruck, ohne feste Gruppen und mit maximaler Freiheit.',

about_personal: 'Persönlicher Service',
about_personal_text: 'Von Ihrer ersten Nachricht bis zur Rückfahrt ins Hotel stehen wir Ihnen persönlich zur Seite – schnell, zuverlässig und jederzeit erreichbar.',
  about_stats_tours: 'Ausflüge',
  about_stats_guests: 'Zufriedene Gäste',
  about_stats_years: 'Jahre Erfahrung',
  about_stats_guides: 'Guides & Ägyptologen',

  // === Reviews ===
  reviews_title: 'Was unsere Gäste sagen',
  reviews_subtitle: 'Erfahrungen von Reisenden, die mit uns Ägypten entdeckt haben',
  reviews_verified: 'Verifizierte Bewertung',

    // === Contact ===
  contact_title: 'Kontakt & Buchung',
  contact_subtitle: 'Wir sind für Sie da – persönlich, schnell und zuverlässig.',
  contact_form_title: 'Ihre Anfrage',
  contact_name: 'Ihr Name',
  contact_email: 'Ihre E-Mail-Adresse',
  contact_phone_label: 'Ihre Telefonnummer',
  contact_subject: 'Betreff',
  contact_message: 'Ihre Nachricht',
  contact_send: 'Anfrage senden',
  contact_success: 'Anfrage gesendet!',
  contact_success_message: 'Vielen Dank! Wir melden uns innerhalb von 24 Stunden bei Ihnen.',
  contact_whatsapp: 'WhatsApp',
  contact_call: 'Anrufen',
  contact_email_us: 'E-Mail',
  contact_location: 'Unser Standort',
  contact_hours: 'Persönlicher Service',
  contact_hours_text: 'Täglich für Sie erreichbar',

  contact_request_type: 'Art der Anfrage',
  contact_excursion: 'Ausflug',
  contact_transfer: 'Flughafentransfer',
  contact_private_transfer: 'Privater Transfer',
  contact_general: 'Allgemeine Anfrage',
  contact_travel_date: 'Reisedatum',
  contact_guests: 'Anzahl der Personen',
  contact_hotel: 'Hotel / Unterkunft',
  contact_flight_number: 'Flugnummer (optional)',
  contact_special_requests: 'Besondere Wünsche',
  contact_select_option: 'Bitte auswählen',
  contact_whatsapp_booking: 'Über WhatsApp anfragen',

  // === Footer ===
  footer_company_desc: 'Yallabina Tours ist Ihr zuverlässiger Partner für private Ausflüge, Transfers und deutschsprachige Reiseleitung in Ägypten. Persönlicher Service, faire Preise und unvergessliche Erlebnisse.',
  footer_quick_links: 'Schnellzugriff',
  footer_services: 'Unsere Services',
  footer_contact_info: 'Kontakt',
  footer_legal: 'Rechtliches',
  footer_privacy: 'Datenschutz',
  footer_terms: 'AGB',
  footer_imprint: 'Impressum',
  footer_copyright: '©2026 Yallabina Tours. Alle Rechte vorbehalten.',
  footer_newsletter: 'Newsletter',
  footer_newsletter_desc: 'Erhalten Sie aktuelle Reiseangebote und Ausflugstipps für Ägypten.',
  footer_email_placeholder: 'Ihre E-Mail-Adresse',
  footer_subscribe: 'Abonnieren',
  footer_follow_us: 'Folgen Sie uns',
footer_whatsapp_booking: 'Jetzt per WhatsApp buchen',

  // === Common ===
  read_more: 'Weiterlesen',
  show_more: 'Mehr anzeigen',
  show_less: 'Weniger anzeigen',
  loading: 'Wird geladen...',
  error: 'Ein Fehler ist aufgetreten',
  retry: 'Erneut versuchen',
  search: 'Suchen',
  language: 'Sprache',
  currency: 'Währung',
  days: 'Tage',
  hours: 'Stunden',
  minutes: 'Minuten',
  back: 'Zurück',
  submit: 'Absenden',
  cancel: 'Abbrechen',
  close: 'Schließen',
};